/**
 * Functionality to read a file form the drive and upload it.
 * From a serverside perspective it resembles what happens, when a standard html form is submitted
 * 
 * Inclued is a bunch of "events" that can be overwritten in implementing classes.
 * These gives feedback on the file upload progress, when it is done and any errors that might occur.
 *
 * @param {File} file   The file that is to be uploaded.
 * @param {Array} extraFields An array of objects on the form: {name: string, value: string}. Resembles the value of input fields in a standard html-form.
 * @param {String} destination The destination of the post request. This resembles the "action" attribute of a standard html form-tag.
 * @constructor
 */
class Fileupload {
    constructor(file, exstraFields, destination) {
        this.file = file;
        
        // If the destination is empty, post the file, to the current page (IE can't handle an empty url in the XMLHttpRequest)
        this.url = (destination ? destination : location.href);
         
        // This will be the name of the file in the post data when it is received on the server. If you want a different name, simply overwrite it in the implmenting class. Eg. myFileuploader.uploadname = "myfile";
        this.uploadname = "uploadedfile";

        // The FileReader is used to read the file from the disk into a bytearray
        this.reader = new FileReader();
        // The XMLHttpRequest is used to make the post to the server.
        this.xhr = new XMLHttpRequest();

        // The file has been read. Now it is time to upload it. 
        this.reader.onload = this.onload = () => {
            this.onreaderend("File read successfully");

            // The FormData class is used to represent the data (the file as well as any optional extra fields) that is submitted. The encoding is "multipart/form-data" just like in a normal form submit.
            var formdata = new FormData();
            formdata.append(this.uploadname, this.file);

            [].forEach.call(exstraFields, (f) => {
                formdata.append(f.name, f.value);
            });
    
            let async = true;
            this.xhr.open("POST", this.url, async);

            this.xhr.send(formdata);
        };
        // this.reader.onabort = this.readerOnabort.bind(this);
        // this.reader.onerror = this.readerOnerror.bind(this);
        // this.reader.onloadend = this.readerOnloadend.bind(this);
        // this.reader.onloadstart = this.readerOnloadstart.bind(this);
        // this.reader.onprogress = this.onprogress.bind(this);


        // FileReader
        this.reader.onloadstart = () => { 
            this.onreaderstart("Starting to read file from the disk");
            this.onloadstart("Upload initiated");
        };
        this.reader.onprogress = (ev) => { this.onreaderprogress("File is being read", ev.loaded, ev.total); };
        this.reader.onloadend = (ev) => { this.onreaderend("File read", ev.loaded, ev.total); };
        this.xhr.onabort = (ev) => {
            this.onreaderabort(`File reader aborted: ${ev.error}`);
            this.onabort(`Upload aborted: ${ev.error}`);
        };
        this.reader.onerror = (ev) => {
            this.onreadererror(`File reader error: ${ev.error}`);
            this.onerror(`Error: ${ev.error}`);
        };

        // XMLHttpRequest
        this.xhr.onloadstart = () => { this.onuploadstart("XHR start"); };
        this.xhr.upload.onprogress = (ev) => {
            this.onuploadprogress("XHR is sending data", ev.loaded, ev.total);
            this.onprogress("Uploading", ev.loaded, ev.total);
        };
        this.xhr.onloadend = (ev) => {
            this.onuploadend("Uploaded", ev.loaded, ev.total);
            this.onloadend("Uploaded", ev.loaded, ev.total);
        };
        this.xhr.onabort = (ev) => {
            this.onuploadabort(`XHR aborted: ${ev.error}`);
            this.onabort(`Upload aborted: ${ev.error}`);
        };
        this.xhr.onerror = (ev) => {
            this.onuploaderror(`XHR error: ${ev.error}`);
            this.onerror(`Error: ${ev.error}`);
        };
       
    }

    /** Overwrite any of these empty methods in implementing classes to get feedback when these events occur. **/

    // This first section is events specifically to the FileReader object. 
    onreaderstart(status) { window.console.log("onreaderstart", status); }
    onreaderprogress(status, position, total) { window.console.log("onreaderprogress", status, position, total); }
    onreaderend(status, position, total) { window.console.log("onreaderend", status, position, total); }
    onreaderabort(status) { window.console.log("onreaderabort", status); }
    onreadererror(status) { window.console.log("onreadererror", status); }
        
    // This second section is events specifically to the XMLHttpRequest object. 
    onuploadstart(status) { window.console.log("onuploadstart", status); }
    onuploadprogress(status, position, total) { window.console.log("onuploadprogress", status, position, total); }
    onuploadend(status, position, total) { window.console.log("onuploadend", status, position, total); }
    onuploadabort(status) { window.console.log("onuploadabort", status); }
    onuploaderror(status) { window.console.log("onuploaderror", status); }
 
    // This third and final section is a simplified combination of events. These are the ones you in most cases want to overwrite in your implementing class.
    onloadstart(status) { window.console.log("onloadstart", status); }
    onprogress(status, position, total) { window.console.log("onprogress", status, position, total); }
    onloadend(status, position, total) { window.console.log("onloadend", status, position, total); }
    onabort(status) { window.console.log("onabort", status); }
    onerror(status) { window.console.log("onerror", status); }


    /**
     * Initiates the file upload.
     * 
     **/
    upload() {
        // Read the file from the disk. Notice this causes the "onload" event on the FileReader object, which in this implementation initiates the XMLHttpRequest and then uploads the file to the server. See the constructor for the implementation of this.
        this.reader.readAsArrayBuffer(this.file);
    }
}

export default Fileupload;